<template>
	<v-container>

	</v-container>
</template>

<script>


export default {
	data() {
		return {
			EsgYear: [],
			selectedYear: null,
		}
	},
	mounted() {

	},
	created() {

	},
	
	methods: {


	},
}
</script>

<style scoped>
body {
	margin: 1%;
	padding: 0;
	align-items: center;
}
.contentRow {
	margin: 0px;
	justify-content: center;
}

.nav ul {
	margin: 0;
}

.nav li {
	display: inline;
}
.nav a {
	display: inline-block;
	padding: 0.5em;
	color: gray;
	font: inherit;
	margin: 10px;
	text-decoration: none;
	font-weight: bolder;
}

.nav a:hover {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}

.main-nav {
	width: auto;
	text-align: center;
	font-size: 1.2em;
	margin-top: 0;
	padding: 0 0;
}

.main-nav li {
	padding: 0;
}
a.router-link-active {
	border-bottom: 4px solid #1e7c83;
	font-weight: bolder;
	color: #1e7c83;
}
</style>


